const env = process.env.NODE_ENV;
const prodUri = 'https://cms.iglesialamies.org';
const devUri = 'http://localhost:1337';


export const host = env === 'development' ? devUri : prodUri;